import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Logo } from "./Logo";

const COLS = [
  {
    title: "Shop",
    links: [
      { to: "/shop", label: "All Products" },
      { to: "/workbooks", label: "Workbooks" },
      { to: "/worksheets", label: "Worksheets" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About" },
      { to: "/faq", label: "FAQ" },
      { to: "/contact", label: "Contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms & Conditions" },
      { to: "/refund", label: "Refund Policy" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t-4 border-white bg-sky-100">
    <div className="mx-auto grid max-w-6xl gap-10 px-6 py-14 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo className="text-lg" />
        <p className="mt-3 font-display text-sm font-bold uppercase tracking-[0.25em] text-slate-500">
          Play <Heart className="inline h-3.5 w-3.5 fill-brand-red text-brand-red" /> Learn{" "}
          <Heart className="inline h-3.5 w-3.5 fill-brand-red text-brand-red" /> Grow
        </p>
        <p className="mt-4 text-sm font-semibold leading-relaxed text-slate-500">
          Fun, colorful and printable educational resources for young children.
        </p>
      </div>
      {COLS.map((col) => (
        <nav key={col.title} aria-label={col.title}>
          <h3 className="font-display text-base font-bold uppercase tracking-wider text-slate-700">
            {col.title}
          </h3>
          <ul className="mt-4 space-y-2.5">
            {col.links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="text-sm font-semibold text-slate-500 transition-colors hover:text-brand-blue"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
    <div className="border-t border-sky-200 py-5 text-center">
      <p className="font-display text-base font-bold text-slate-600">
        Small Steps <Heart className="inline h-4 w-4 fill-brand-red text-brand-red" /> Big Dreams
      </p>
      <p className="mt-1 text-xs font-semibold text-slate-400">
        © 2026 Divine Kids Learning · Made with love in India
      </p>
    </div>
  </footer>
);
